// removed by extract-text-webpack-plugin
module.exports = {"part":"theme__part___1yzye","active":"theme__active___25ODM"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Part/theme.scss
// module id = 1280
// module chunks = 0